import API from 'utils/api';
import { onSuccess, onError } from 'utils/handlers';
import getFormattedValues, { formatReceived, hasFiles } from 'utils/formatValues';

export const baseURI = 'catalogos/periodos-fiscales/';

/**
 * GET Periodos Fiscales
 * @returns {Promise<Array<object>>}
 */
export const getPeriodosFiscales = async () => {
  try {
    const response = await API.get(baseURI);
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * GET Periodo Fiscal
 * @param {number} id
 * @returns {Promise<object>}
 */
export const getPeriodoFiscal = async (id) => {
  try {
    const response = await API.get(`${baseURI}${id}`);
    return response.data;
  } catch (err) {
    onError(err);
    return null;
  }
};

/**
 * POST Periodo Fiscal
  * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postPeriodoFiscal = async (values) => {
  try {
    // eslint-disable-next-line no-param-reassign
    values.periodo = values.periodo?.format('YYYY');
    const files = ['documento_anexo_PDF', 'documento_anexo_word'];
    const config = hasFiles(values, files) ? {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    } : {};
    const formattedvalues = getFormattedValues(values, {
      files,
      formData: config.headers,
      clean: true,
    });
    const response = await API.post(baseURI, formattedvalues);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Periodo Fiscal
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchPeriodoFiscal = async (id, values) => {
  try {
    // eslint-disable-next-line no-param-reassign
    values.periodo = values.periodo?.format('YYYY');
    const files = ['documento_anexo_PDF', 'documento_anexo_word'];
    const config = hasFiles(values, files) ? {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    } : {};
    const formattedvalues = getFormattedValues(values, {
      files,
      formData: config.headers,
      clean: true,
    });
    const response = await API.patch(`${baseURI}${id}`, formattedvalues);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Periodo Fiscal
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const deletePeriodoFiscal = async (id) => {
  try {
    const response = await API.delete(`${baseURI}${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
